import React, { Suspense, lazy } from 'react'
import { Menu, Loader,  Icon, Sidebar, Grid, Dropdown, Image, Divider, Dimmer,   Button,Input, Form} from 'semantic-ui-react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { Segment } from 'semantic-ui-react';
 import {Auth} from 'aws-amplify';
import SidebarIzquierda from '../sidebar/ManageSidebarIzquierda';
import ManageFinSession from '../finSession/ManageFinSession';
import { useParams } from 'react-router-dom';

import Home from '../home/ManageHome'; 
import TagList from '../tag/ManageTagList'; 
import TagForm from '../tag/ManageTagForm'; 
import LoginForm from '../login/ManageLoginForm'; 
import Curso from '../curso/ManageCurso'; 
import Miespacio from '../miespacio/ManageMiespacio'; 

import PagoLinea from '../pagoPaypal/ManagePagosLinea'; 

import Insignias from '../insignias/Insignias'; 
import ManageInsigniasInfo from '../insignias/ManageInsigniasInfo'; 
import Pago from '../pago/ManagePago'; 
import ContenidoList from  '../contenido/ManageContenidoList';
import ContenidoForm from  '../contenido/ManageContenidoForm';
import Cuestionario from  '../cuestionario/ManageCuestionario';
import Cursoplay from '../miespacio/ManageCursoplay'; 
import ModuloList from  '../modulo/ManageModuloList';
import ModuloForm from  '../modulo/ManageModuloForm';
import CursoList from  '../cursocatalogo/ManageCursoList';
import CursoForm from  '../cursocatalogo/ManageCursoForm';



import Registro from '../registro/ManageRegistro';
import Homecat from '../homecat/ManageHomecat';
import UsuarioList from  '../usuario/ManageUsuarioList';
import UsuarioForm from  '../usuario/ManageUsuarioForm';
import CompletarRegistroForm from  '../usuario/ManageCompletarRegistroForm';
import FormularioList from  '../formulario/ManageFormularioList';
import FormularioForm from  '../formulario/ManageFormularioForm';
import ExamenList from  '../examen/ManageExamenList';
import ExamenForm from  '../examen/ManageExamenForm';
import ExamenTest from  '../examen/ManageExamen';
import PreguntaList from  '../pregunta/ManagePreguntaList';
import PreguntaForm from  '../pregunta/ManagePreguntaForm';
import RespuestaList from  '../respuesta/ManageRespuestaList';
import RespuestaForm from  '../respuesta/ManageRespuestaForm';
import InsigniaList from  '../insignia/ManageInsigniaList';
import InsigniaForm from  '../insignia/ManageInsigniaForm';  
import PreguntasFrecuentesList from  '../preguntasfrecuentes/ManagePreguntasFrecuentesList';
import PreguntasFrecuentesForm from  '../preguntasfrecuentes/ManagePreguntasFrecuentesForm';
import CursoAprendizajeList from  '../cursoaprendizaje/ManageCursoAprendizajeList';
import CursoAprendizajeForm from  '../cursoaprendizaje/ManageCursoAprendizajeForm';
import ManageReporteCurso from  '../reportesCursos/ManageReporteCurso';
import ManageReportes from  '../reportes/ManageReportes';
import CursoOpinionList from  '../cursoopinion/ManageCursoOpinionList';
import CursoOpinionForm from  '../cursoopinion/ManageCursoOpinionForm';
import CursoConstanciaList from  '../cursoconstancia/ManageCursoConstanciaList';
import CursoConstanciaForm from  '../cursoconstancia/ManageCursoConstanciaForm';
import ManageInscripcion from  '../inscripcion/ManageInscripcion';
import ManageBorrarInscripcion from  '../inscripcion/borrarInscripcion/ManageBorrarInscripcion';
import PagosList from  '../pagos/ManagePagosList';
import PagosForm from  '../pagos/ManagePagosForm';
import ReferenciaBancariaList from  '../referenciabancaria/ManageReferenciaBancariaList';
import ReferenciaBancariaForm from  '../referenciabancaria/ManageReferenciaBancariaForm';
import TipoMonedaList from  '../tipomoneda/ManageTipoMonedaList';
import TipoMonedaForm from  '../tipomoneda/ManageTipoMonedaForm';
import CursoTipoMonedaList from  '../cursotipomoneda/ManageCursoTipoMonedaList';
import CursoTipoMonedaForm from  '../cursotipomoneda/ManageCursoTipoMonedaForm';
import CrucigramaList from  '../crucigrama/ManageCrucigramaList';
import CrucigramaForm from  '../crucigrama/ManageCrucigramaForm';
import CrucigramaPalabrasList from  '../crucigramapalabras/ManageCrucigramaPalabrasList';
import CrucigramaPalabrasForm from  '../crucigramapalabras/ManageCrucigramaPalabrasForm';
import UsuarioCursoList from  '../usuariocurso/ManageUsuarioCursoList';
import UsuarioCursoForm from  '../usuariocurso/ManageUsuarioCursoForm';
import PreviewCurso from  '../previsualizarCurso/ManageCursoView';
//import configuraCurso from  '../ConfigurarCurso/ManageCursoView';
import Configuracurso from '../ConfigurarCurso/ManageConfiguraCurso';
import ManageCorreoForm  from  '../correos/ManageCorreoForm';
import ContableRegistroGastoList from  '../contableregistrogasto/ManageContableRegistroGastoList';
import ContableRegistroGastoForm from  '../contableregistrogasto/ManageContableRegistroGastoForm';
import CursosProfesor from  '../profesores/ManageCursosProfesor';
import PaisList from  '../pais/ManagePaisList';
import PaisForm from  '../pais/ManagePaisForm';
import CiudadList from  '../ciudad/ManageCiudadList';
import CiudadForm from  '../ciudad/ManageCiudadForm';
import RegionList from  '../region/ManageRegionList';
import RegionForm from  '../region/ManageRegionForm';
import CursoListN from  '../cursocatalogonuevo/ManageCursoList';
import CursoFormN from  '../cursocatalogonuevo/ManageCursoForm';
import DescuentoList from  '../descuento/ManageDescuentoList';
import DescuentoForm from '../descuento/ManageDescuentoForm';

import CargarForm from '../cargarConstancias/ManageCargarRegistros';


const countryOptions = [
    { key: 'es', value: 'es', flag: 'mx', text: 'Español' },
    { key: 'en', value: 'en', flag: 'gb', text: 'English' },
    { key: 'pt', value: 'pt', flag: 'br', text: 'Portugues' }  
];

/*
  <Menu.Item>
    <Input icon='search' size="mini" placeholder={strings?strings["Buscar"]:""}/>
</Menu.Item>

 <Menu.Item>
                                <Form size="mini">    
                                <Dropdown
                                    name="idioma"
                                    placeholder='Idioma'
                                    value={idioma}
                                    search
                                    selection
                                    onChange={onChangeIdioma}
                                    options={countryOptions}
                                  />
                                 </Form> 
                            </Menu.Item>    

*/

              

const Header=({  strings, ajaxCallInProgress, signOut, menu, onChange, onChangeIdioma, user, sidebarIzquierda, showSidebarIzquierda, handleSidebarIzquierdaHide, idioma, navigate })=>{
  
    
let pusherStyle={ backgroundColor: '#F0F0F0' };
     let menuActivo=[];
     for(let i=0; i< menu.length; i++){
         if(menu[i].subMenus.length==0){
            menuActivo.push(
                
                <Menu.Item as='a' header>
                    <Link to={menu[i].url}>{strings?strings[menu[i].descripcion]:""}</Link>
                </Menu.Item>
            );
        }else{
            let hijos=[];
            let submenus=menu[i].subMenus;
            for(let j=0; j< submenus.length; j++){
                hijos.push(
                <Link to={submenus[j].url}> 
                    <Dropdown.Item style={{color:"black"}}>
                    {strings?strings[submenus[j].descripcion]:""}
                    </Dropdown.Item> 
                </Link>
                        
                );
            }
            
            menuActivo.push(
            <Dropdown item text={strings?strings[menu[i].descripcion]:""}>
                <Dropdown.Menu>
                    {hijos.map(sub =>
                                sub
                    )}
                </Dropdown.Menu>        
            </Dropdown>);
        }
         
     }
    
	return (
        <React.StrictMode>
        <div>
        <ManageFinSession />
            <Grid>
                <Grid.Row only='computer tablet'> 
                    <Menu fixed='top'   inverted size="large">
        
                        
                         {user!=null?
                            <Menu.Item  onClick={handleSidebarIzquierdaHide} >
                                <Icon  name='sidebar' />
                            </Menu.Item>
                            :
                            ""
                         }
        
                        <Link to="/">
                            <Menu.Item as='a' header>
                                <Image size='mini' src='/images/logo.png' style={{ marginRight: '4.5em' }}/>
                                Quality Academics
                            </Menu.Item>
                        </Link>
                 
          
        
                        {menuActivo.map(menu =>
                                    menu
                        )}

                        {user!=null && user==5?
                            <div>
                             <Menu.Item as='a' header>
                               <Link to="/cuestionario">cuestionario</Link>
                            </Menu.Item>

                            <Menu.Item as='a' header>
                               <Link to="/formularios">formularios</Link>
                            </Menu.Item>

                            <Menu.Item as='a' header>
                               <Link to="/preguntas">preguntas</Link>
                            </Menu.Item>
                            </div>

                            :""
                        }

           
                        <Menu.Menu position='right'>
                            <Menu.Item>
                                <Form size="mini">    
                                <Dropdown
                                    name="idioma"
                                    placeholder='Idioma'
                                    value={idioma}
                                    search
                                    selection
                                    onChange={onChangeIdioma}
                                    options={countryOptions}
                                  />
                                 </Form> 
                            </Menu.Item>    

                           

                        {user==null?
                            <Menu.Item as='a' header>
                                <Link to="/miespacio"><Button color="blue" size="mini">{strings?strings["login"]:""}</Button></Link>
                            </Menu.Item>
                            :

                            <Menu.Item as='a' header>
                                <Link to="/"><Button size="mini" color="orange" onClick={signOut}>{strings?strings["logout"]:""}</Button></Link>
                            </Menu.Item>

                        }
                </Menu.Menu>
            </Menu>
            </Grid.Row>
            <Grid.Row only='mobile'> 
                    <Menu fixed='top' inverted fluid>
                        
                        {user!=null?
                        
                            <Menu.Item  onClick={handleSidebarIzquierdaHide} >
                                <Icon  name='sidebar' />
                            </Menu.Item>
                        :
                            ""
                        }
        
                        <Link to="/">
                            <Menu.Item as='a' header>
                                <Image size='mini' src='/images/logo.png' style={{ marginRight: '4.5em' }}/>
                            </Menu.Item>
                        </Link>
                 
          
        
                        {menuActivo.map(menu =>
                                    menu
                        )}

                        {user!=null && user==5?
                            <div>
                             <Menu.Item as='a' header>
                               <Link to="/cuestionario">cuestionario</Link>
                            </Menu.Item>

                            <Menu.Item as='a' header>
                               <Link to="/formularios">formularios</Link>
                            </Menu.Item>

                            <Menu.Item as='a' header>
                               <Link to="/preguntas">preguntas</Link>
                            </Menu.Item>
                            </div>

                            :""
                        }

           
                        <Menu.Menu position='right'>
                            
                            <Menu.Item>
                                <Form size="mini">    
                                <Dropdown
                                    name="idioma"
                                    placeholder='Idioma'
                                    value={idioma}
                                    search
                                    selection
                                    onChange={onChangeIdioma}
                                    options={countryOptions}
                                  />
                                 </Form> 
                            </Menu.Item>         
                          
                        {user==null?
                            <Menu.Item as='a' header>
                                <Link to="/miespacio"><Button color="blue" size="mini">{strings?strings["login"]:""}</Button></Link>
                            </Menu.Item>
                            :

                                <Menu.Item as='a' header>
                                    <Link to="/"><Button size="mini" color="orange" onClick={signOut}>{strings?strings["logout"]:""}</Button></Link>
                                </Menu.Item>

                        }
                </Menu.Menu>
            </Menu>
            </Grid.Row>    
            
                
                
                
                
        </Grid>
          <Suspense fallback={
            <Segment >
                    <Loader size='big' inline content='Procesando'/>
            </Segment>
            }>
        {sidebarIzquierda? 
        
        
             <Sidebar.Pushable as={Segment} >
              <Sidebar
                 
                animation="push"
                icon='labeled'
                   
                width='wide' 
                vertical
                visible={showSidebarIzquierda && sidebarIzquierda}
                  
              >
                <SidebarIzquierda />
              </Sidebar>
             <Sidebar.Pusher style={pusherStyle}>
            <Routes>
                <Route path="/contenidos" element={<ContenidoList/>} />
                <Route path="/contenido/:id"  element={<ContenidoForm navigate={navigate}/>} />
                <Route path="/contenido"  element={<ContenidoForm navigate={navigate}/>} />
                <Route path="/tags" element={<TagList/>} />
                <Route path="/tag/:id" element={<TagForm navigate={navigate}/>} />
                <Route path="/tag" element={<TagForm navigate={navigate}/>} />
                <Route path="/home" element={<Home navigate={navigate}/>} />
                <Route path="/login" element={<LoginForm navigate={navigate}/>} />
                <Route path="/registro" element={<Registro/>} />
                <Route path="/curso/:id" element={<Curso navigate={navigate}/>} />
                <Route path="/curso" element={<Curso navigate={navigate}/>} />
                <Route path="/miespacio" element={<Miespacio navigate={navigate}/>} />
                <Route path="/pagolinea" element={<PagoLinea  navigate={navigate}/>} />
                <Route path="/cursoplay/:id" element={<Cursoplay/>} />
                <Route path="/insigniasinfo" element={<ManageInsigniasInfo/>} />
                <Route path="/pago/:id" element={<Pago  navigate={navigate}/>} />

                <Route path="/cuestionario" element={<CompletarRegistroForm navigate={navigate}/>} />
                
                <Route path="/modulos/:id" element={<ModuloList/>} />
                <Route path="/modulos" element={<ModuloList/>} />
                <Route path="/modulo/:id"  element={<ModuloForm navigate={navigate}/>} />
                <Route path="/modulo"  element={<ModuloForm navigate={navigate}/>} />
                <Route path="/cursoscat" element={<CursoList/>} />
                <Route path="/cursocat/:id"  element={<CursoForm navigate={navigate}/>} />
                <Route path="/cursocat"  element={<CursoForm navigate={navigate}/>} />

                <Route path="/cursoscatn" element={<CursoListN/>} />
                <Route path="/cursocatn/:id"  element={<CursoFormN/>} />
                <Route path="/cursocatn"  element={<CursoFormN/>} />

                <Route path="/usuarios" element={<UsuarioList/>} />
                <Route path="/usuario/:id"  element={<UsuarioForm navigate={navigate}/>} />
                <Route path="/usuario"  element={<UsuarioForm navigate={navigate}/>} />
                <Route path="/completar"  element={<CompletarRegistroForm navigate={navigate}/>} />
                <Route path="/insignias" element={<InsigniaList/>} />
                <Route path="/insignia/:id"  element={<InsigniaForm navigate={navigate}/>} />
                <Route path="/insignia"  element={<InsigniaForm navigate={navigate}/>} />
       
                <Route path="/completar"  element={<CompletarRegistroForm navigate={navigate}/>} />
                <Route path="/formularios" element={<FormularioList/>} />
                <Route path="/formulario/:id"  element={<FormularioForm navigate={navigate}/>} />
                <Route path="/formulario"  element={<FormularioForm navigate={navigate}/>} />
                
                <Route path="/examenTest"  element={<ExamenTest/>} />
                        
                <Route path="/examens" element={<ExamenList/>} />
                <Route path="/examen/:id"  element={<ExamenForm navigate={navigate}/>} />
                <Route path="/examen"  element={<ExamenForm navigate={navigate}/>} />
        
                <Route path="/preguntas" element={<PreguntaList/>} />
                <Route path="/pregunta/:id"  element={<PreguntaForm navigate={navigate}/>} />
                <Route path="/pregunta"  element={<PreguntaForm navigate={navigate}/>} />
                <Route path="/respuestas" element={<RespuestaList/>} />
                <Route path="/respuesta/:id"  element={<RespuestaForm navigate={navigate}/>} />
                <Route path="/respuesta"  element={<RespuestaForm navigate={navigate}/>} />
                <Route path="/homecat"  element={<Homecat navigate={navigate}/>} />

                <Route path="/preguntasfrecuentess" element={<PreguntasFrecuentesList/>} />
                <Route path="/preguntasfrecuentes/:id"  element={<PreguntasFrecuentesForm navigate={navigate}/>} />
                <Route path="/preguntasfrecuentes"  element={<PreguntasFrecuentesForm navigate={navigate}/>} />

                <Route path="/cursoaprendizajes" element={<CursoAprendizajeList/>} />
                <Route path="/cursoaprendizaje/:id"  element={<CursoAprendizajeForm navigate={navigate}/>} />
                <Route path="/cursoaprendizaje"  element={<CursoAprendizajeForm navigate={navigate}/>} />

                <Route path="/reportesCurso"  element={<ManageReporteCurso/>} />
                <Route path="/inscripcion"  element={<ManageInscripcion/>} />
                <Route path="/infoInscripcion"  element={<ManageBorrarInscripcion/>} />
                
                
                <Route path="/reportes"  element={<ManageReportes/>} />
                

                <Route path="/cursoopinions" element={<CursoOpinionList/>} />
                <Route path="/cursoopinion/:id"  element={<CursoOpinionForm navigate={navigate}/>} />
                <Route path="/cursoopinion"  element={<CursoOpinionForm navigate={navigate}/>} />

                <Route path="/cursoconstancias" element={<CursoConstanciaList/>} />
                <Route path="/cursoconstancia/:id"  element={<CursoConstanciaForm navigate={navigate}/>} />
                <Route path="/cursoconstancia"  element={<CursoConstanciaForm navigate={navigate}/>} />

                <Route path="/pagoss" element={<PagosList/>} />
                <Route path="/pagos/:id"  element={<PagosForm navigate={navigate}/>} />
                <Route path="/pagos"  element={<PagosForm navigate={navigate}/>} />

                <Route path="/referenciabancarias" element={<ReferenciaBancariaList/>} />
                <Route path="/referenciabancaria/:id"  element={<ReferenciaBancariaForm navigate={navigate}/>} />
                <Route path="/referenciabancaria"  element={<ReferenciaBancariaForm navigate={navigate}/>} />  }

                <Route path="/tipomonedas" element={<TipoMonedaList/>} />
                <Route path="/tipomoneda/:id"  element={<TipoMonedaForm navigate={navigate}/>} />
                <Route path="/tipomoneda"  element={<TipoMonedaForm navigate={navigate}/>} />

                <Route path="/cursotipomonedas" element={<CursoTipoMonedaList/>} />
                <Route path="/cursotipomoneda/:id"  element={<CursoTipoMonedaForm navigate={navigate}/>} />
                <Route path="/cursotipomoneda"  element={<CursoTipoMonedaForm navigate={navigate}/>} />

                <Route path="/crucigramas" element={<CrucigramaList/>} />
                <Route path="/crucigrama/:id"  element={<CrucigramaForm navigate={navigate}/>} />
                <Route path="/crucigrama"  element={<CrucigramaForm navigate={navigate}/>} />

                <Route path="/crucigramapalabrass" element={<CrucigramaPalabrasList/>} />
                <Route path="/crucigramapalabras/:id"  element={<CrucigramaPalabrasForm navigate={navigate}/>} />
                <Route path="/crucigramapalabras"  element={<CrucigramaPalabrasForm navigate={navigate}/>} />

                <Route path="/usuariocursos" element={<UsuarioCursoList/>} />
                <Route path="/usuariocurso/:id"  element={<UsuarioCursoForm navigate={navigate}/>} />
                <Route path="/usuariocurso"  element={<UsuarioCursoForm navigate={navigate}/>} />

                <Route path="/cursoTest/:id"  element={<PreviewCurso  navigate={navigate}/>} />
                <Route path="/configuracurso/:id"  element={<Configuracurso navigate={navigate}/>} />

                <Route path="/correos"  element={<ManageCorreoForm navigate={navigate}/>} />

                <Route path="/contableregistrogastos" element={<ContableRegistroGastoList/>} />
                <Route path="/contableregistrogasto/:id"  element={<ContableRegistroGastoForm navigate={navigate}/>} />
                <Route path="/contableregistrogasto"  element={<ContableRegistroGastoForm navigate={navigate}/>} />

                <Route path="/cursoprofesor"  element={<CursosProfesor/>} />

                <Route path="/paiss" element={<PaisList/>} />
                <Route path="/pais/:id"  element={<PaisForm navigate={navigate}/>} />
                <Route path="/pais"  element={<PaisForm navigate={navigate}/>} />

                <Route path="/ciudads" element={<CiudadList/>} />
                <Route path="/ciudad/:id"  element={<CiudadForm navigate={navigate}/>} />
                <Route path="/ciudad"  element={<CiudadForm navigate={navigate}/>} />

                <Route path="/regions" element={<RegionList/>} />
                <Route path="/region/:id"  element={<RegionForm navigate={navigate}/>} />
                <Route path="/region"  element={<RegionForm navigate={navigate}/>} />

                    
                
                <Route path="/descuentos" element={<DescuentoList/>} />
                <Route path="/descuento/:id"  element={<DescuentoForm navigate={navigate}/>}/>
                <Route path="/descuento"  element={<DescuentoForm navigate={navigate}/>} />    
        
                    
                    
                
                 <Route path="/cargarConstancias"  element={<CargarForm navigate={navigate}/>} /> 
                    
                    
                <Route path="/" element={<Home navigate={navigate}/>} /> 
        
        
                
                         

                     
                 </Routes>
        
         </Sidebar.Pusher>
        </Sidebar.Pushable> 
        :
        <Routes>
                <Route path="/contenidos" element={<ContenidoList/>} />
                <Route path="/contenido/:id"  element={<ContenidoForm navigate={navigate}/>} />
                <Route path="/contenido"  element={<ContenidoForm navigate={navigate}/>} />
                <Route path="/tags" element={<TagList/>} />
                <Route path="/tag/:id" element={<TagForm navigate={navigate}/>} />
                <Route path="/tag" element={<TagForm navigate={navigate}/>} />
                <Route path="/home" element={<Home navigate={navigate}/>} />
                <Route path="/login" element={<LoginForm navigate={navigate}/>} />
                <Route path="/registro" element={<Registro/>} />
                <Route path="/curso/:id" element={<Curso navigate={navigate}/>} />
                <Route path="/curso" element={<Curso navigate={navigate}/>} />
                <Route path="/miespacio" element={<Miespacio  navigate={navigate}/>} />
                <Route path="/pagolinea" element={<PagoLinea  navigate={navigate}/>} />
                <Route path="/pagolinea" element={<PagoLinea  navigate={navigate}/>} />            
             
                <Route path="/cursoplay/:id" element={<Cursoplay/>} />
               
                <Route path="/pago/:id" element={<Pago  navigate={navigate} />} />
                <Route path="/insigniasinfo" element={<ManageInsigniasInfo/>} />

                <Route path="/modulos" element={<ModuloList  navigate={navigate}/>} />
                <Route path="/modulo/:id"  element={<ModuloForm navigate={navigate}/>} />
                <Route path="/modulo"  element={<ModuloForm navigate={navigate}/>} />

                <Route path="/cursoscat" element={<CursoList/>} />
                <Route path="/cursocat/:id"  element={<CursoForm navigate={navigate}/>} />
                <Route path="/cursocat"  element={<CursoForm navigate={navigate}/>} />

                <Route path="/cursoscatn" element={<CursoListN/>} />
                <Route path="/cursocatn/:id"  element={<CursoFormN/>} />
                <Route path="/cursocatn"  element={<CursoFormN/>} />

                <Route path="/usuarios" element={<UsuarioList/>} />
                <Route path="/usuario/:id"  element={<UsuarioForm navigate={navigate}/>} />
                <Route path="/usuario"  element={<UsuarioForm navigate={navigate}/>} />
                <Route path="/completar"  element={<CompletarRegistroForm navigate={navigate}/>} />
                <Route path="/insignias" element={<InsigniaList/>} />
                <Route path="/insignia/:id"  element={<InsigniaForm navigate={navigate}/>} />
                <Route path="/insignia"  element={<InsigniaForm navigate={navigate}/>} />
                <Route path="/homecat"  element={<Homecat navigate={navigate}/>} />

                <Route path="/cuestionario" element={<CompletarRegistroForm navigate={navigate}/>} />
                
                <Route path="/formularios" element={<FormularioList/>} />
                <Route path="/formulario/:id"  element={<FormularioForm navigate={navigate}/>} />
                <Route path="/formulario"  element={<FormularioForm navigate={navigate}/>} />
                    
                <Route path="/examens" element={<ExamenList/>} />
                <Route path="/examen/:id"  element={<ExamenForm navigate={navigate}/>} />
                <Route path="/examen"  element={<ExamenForm navigate={navigate}/>} />
                
                <Route path="/examenTest"  element={<ExamenTest/>} />
                    
                <Route path="/preguntasfrecuentess" element={<PreguntasFrecuentesList/>} />
                <Route path="/preguntasfrecuentes/:id"  element={<PreguntasFrecuentesForm navigate={navigate}/>} />
                <Route path="/preguntasfrecuentes"  element={<PreguntasFrecuentesForm navigate={navigate}/>} />

                <Route path="/cursoaprendizajes" element={<CursoAprendizajeList/>} />
                <Route path="/cursoaprendizaje/:id"  element={<CursoAprendizajeForm navigate={navigate}/>} />
                <Route path="/cursoaprendizaje"  element={<CursoAprendizajeForm navigate={navigate}/>} />

                <Route path="/reportesCurso"  element={<ManageReporteCurso/>} />
                <Route path="/inscripcion"  element={<ManageInscripcion/>} />
                <Route path="/infoInscripcion"  element={<ManageBorrarInscripcion/>} />
                
                <Route path="/reportes"  element={<ManageReportes/>} />

                <Route path="/cursoopinions" element={<CursoOpinionList/>} />
                <Route path="/cursoopinion/:id"  element={<CursoOpinionForm navigate={navigate}/>} />
                <Route path="/cursoopinion"  element={<CursoOpinionForm navigate={navigate}/>} />  

                <Route path="/cursoconstancias" element={<CursoConstanciaList/>} />
                <Route path="/cursoconstancia/:id"  element={<CursoConstanciaForm navigate={navigate}/>} />
                <Route path="/cursoconstancia"  element={<CursoConstanciaForm navigate={navigate}/>} />

                <Route path="/pagoss" element={<PagosList/>} />
                <Route path="/pagos/:id"  element={<PagosForm navigate={navigate}/>} />
                <Route path="/pagos"  element={<PagosForm navigate={navigate}/>} />

                <Route path="/referenciabancarias" element={<ReferenciaBancariaList/>} />
                <Route path="/referenciabancaria/:id"  element={<ReferenciaBancariaForm navigate={navigate}/>} />
                <Route path="/referenciabancaria"  element={<ReferenciaBancariaForm navigate={navigate}/>} />

                <Route path="/tipomonedas" element={<TipoMonedaList/>} />
                <Route path="/tipomoneda/:id"  element={<TipoMonedaForm navigate={navigate}/>} />
                <Route path="/tipomoneda"  element={<TipoMonedaForm navigate={navigate}/>} />

                <Route path="/cursotipomonedas" element={<CursoTipoMonedaList/>} />
                <Route path="/cursotipomoneda/:id"  element={<CursoTipoMonedaForm navigate={navigate}/>} />
                <Route path="/cursotipomoneda"  element={<CursoTipoMonedaForm navigate={navigate}/>} />

                <Route path="/crucigramas" element={<CrucigramaList/>} />
                <Route path="/crucigrama/:id"  element={<CrucigramaForm navigate={navigate}/>} />
                <Route path="/crucigrama"  element={<CrucigramaForm navigate={navigate}/>} />

                <Route path="/crucigramapalabrass" element={<CrucigramaPalabrasList/>} />
                <Route path="/crucigramapalabras/:id"  element={<CrucigramaPalabrasForm navigate={navigate}/>} />
                <Route path="/crucigramapalabras"  element={<CrucigramaPalabrasForm navigate={navigate}/>} />
                                        
                <Route path="/usuariocursos" element={<UsuarioCursoList/>} />
                <Route path="/usuariocurso/:id"  element={<UsuarioCursoForm navigate={navigate}/>} />
                <Route path="/usuariocurso"  element={<UsuarioCursoForm navigate={navigate}/>} />

                <Route path="/cursoTest/:id"  element={<previewCurso navigate={navigate}/>} />
                <Route path="/configuracurso/:id"  element={<Configuracurso navigate={navigate}/>} />

                <Route path="/correos"  element={<ManageCorreoForm navigate={navigate}/>} />

                <Route path="/contableregistrogastos" element={<ContableRegistroGastoList/>} />
                <Route path="/contableregistrogasto/:id"  element={<ContableRegistroGastoForm navigate={navigate}/>} />
                <Route path="/contableregistrogasto"  element={<ContableRegistroGastoForm navigate={navigate}/>} />

                <Route path="/cursoprofesor"  element={<CursosProfesor/>} />

                <Route path="/paiss" element={<PaisList/>} />
                <Route path="/pais/:id"  element={<PaisForm navigate={navigate}/>} />
                <Route path="/pais"  element={<PaisForm navigate={navigate}/>} />

                <Route path="/ciudads" element={<CiudadList/>} />
                <Route path="/ciudad/:id"  element={<CiudadForm navigate={navigate}/>} />
                <Route path="/ciudad"  element={<CiudadForm navigate={navigate}/>} />

                <Route path="/regions" element={<RegionList/>} />
                <Route path="/region/:id"  element={<RegionForm navigate={navigate}/>} />
                <Route path="/region"  element={<RegionForm navigate={navigate}/>} />
                    
                <Route path="/descuentos" element={<DescuentoList/>} />
                <Route path="/descuento/:id"  element={<DescuentoForm navigate={navigate}/>}/>
                <Route path="/descuento"  element={<DescuentoForm navigate={navigate}/>} />          
                
                <Route path="/cargarConstancias"  element={<CargarForm navigate={navigate}/>} /> 
                
                <Route path="/" element={<Home navigate={navigate}/>} /> 
        
        
                     
                </Routes>
        }
           </Suspense>

        </div>
        </React.StrictMode>
	);
};



export default Header ;